import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC, useEffect, useState } from 'react'
import { zenToHan } from '../../../utils/string'

interface Props {
  title: string
  originList: string[]
  defaultValue: string
  callback: (value: string) => void
  zeroPadding?: boolean
  type?: string
}

const SelectAndInput: FC<Props> = (props) => {
  const {
    title,
    originList,
    defaultValue,
    callback,
    zeroPadding,
    type,
  } = props

  const [text, setText] = useState<string>("")
  const [composition, setComposition] = useState<boolean>(false)

  const [displayList, setDisplayList] = useState<boolean>(false)
  const [list, setList] = useState<string[]>([])

  const submitValue = (value: string) => {
    let formatValue = value
    if (type === "number") {
      formatValue = zenToHan(formatValue)
    }
    if (zeroPadding) {
      formatValue = `00${formatValue}`.slice(-2)
    }
    if (value && originList.find((v) => v === formatValue)) {
      setText(formatValue)
      callback(formatValue)
    } else {
      setText(defaultValue)
      callback(defaultValue)
    }
    setList(originList)
    setDisplayList(false)
  }

  const keyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter" && !composition) {
      submitValue(event.currentTarget.value)
    }
  }

  const buildList = (value: string) => {
    setList(originList.filter((v) => v.includes(value)))
    setText(value)
  }

  useEffect(() => {
    setText(defaultValue)
    setList(originList)
  }, [defaultValue])

  return (
    <>
      <div className="select_and_input_wrapper">
        <input
          type="text"
          id={title}
          onClick={() => setDisplayList((cur) => !cur)}
          onChange={(event) => buildList(event.target.value)}
          onKeyDown={(event) => keyDown(event)}
          onCompositionStart={() => setComposition(true)}
          onCompositionEnd={() => setComposition(false)}
          value={text}
        />
        <FontAwesomeIcon
          className="appearance"
          icon={["fas", "angle-down"]}
        />
        {
          displayList && (
            <>
              <div className="select_and_input_list">
                {
                  list.map((v, i) => (
                    <div
                      className="select_item"
                      key={`${title}_${i + 0}`}
                      onClick={() => submitValue(v)}
                      role="none"
                    >
                      {v}
                    </div>
                  ))
                }
              </div>
              <div className="close_screen" role="presentation" onClick={() => submitValue(text)} />
            </>
          )
        }
      </div>
    </>
  )
}

SelectAndInput.defaultProps = {
  zeroPadding: false,
  type: "number",
}

export default SelectAndInput
